import React from 'react'
import styled, { css } from '@xstyled/styled-components'
import { breakpoints } from '@xstyled/system'
import { Container } from '@atoms/Grid'
import { GatsbyImage } from 'gatsby-plugin-image'

const ImageSection = ({ full, ...props }) => {
  if (full) return <GatsbyImage layout={'fullWidth'} {...props} />
  return (
    <S.Container>
      <GatsbyImage {...props} />
    </S.Container>
  )
}

const S = {}

S.Container = styled(Container)`
  ${breakpoints({
    xs: css`
      padding-left: 0;
      padding-right: 0;
    `,
  })}
`

export default ImageSection
